import {
    apiRequest,
    angkaKreditDetail
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", angkaKreditDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository